// extracted by mini-css-extract-plugin
export default {"latestPost":"latestpost_latestPost__qn3Jp"};